<!--多级联动 选择分类-->
<template>
  <div id="cascaderSelect" class="cascader-select">
    <el-cascader
      id="classifyCascader"
      ref="classifyCascader"
      v-model="selectValue"
      :props="propObj"
      :options="optionsTree"
      separator=" > "
      :placeholder="placeholder"
      style="width: 100%"
      :disabled="disabled"
      :clearable="canClear"
      @change="onChange"
      @visible-change="onBlur"
    />
  </div>
</template>

<script>
export default {
  name: 'ClassifySelect',
  props: {
    // 选项数据
    optionsTree: {
      type: Array,
      default() {
        return []
      },
    },
    initValue: {
      // 初始值
      type: [Array, String],
      default() {
        return []
      },
    },
    // el-cascader的 props 对象
    propObj: {
      type: Object,
      default() {
        return {
          label: 'name',
          value: 'code',
          children: 'children',
        }
      },
    },
    leafOnly: {
      // 是否只返回叶子节点的值
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canClear: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择分类'
    }
  },
  data() {
    return {
      selectValue: '',
    }
  },
  watch: {
    initValue: {
      handler() {
        this.selectValue = this.initValue
      },
      immediate: true
    },
  },
  methods: {
    toFocus() {
      document.querySelector('#classifyCascader .el-input').click()
    },
    reset() {
      this.selectValue = this.initValue
    },
    resetPanel() {
      if (this.$refs.classifyCascader) {
        this.$refs.classifyCascader.$refs.panel.activePath = []
        this.$refs.classifyCascader.$refs.panel.syncActivePath()
      }
    },
    onChange(value) {
      if (value && value.length && this.leafOnly) {
        value = value[value.length - 1]
      }
      this.$emit('selected', value)
    },
    onBlur(visible) {
      if (!visible) {
        /* 为了解决下拉选择框不消失的bug，需要延迟触发blur事件 */
        this.$nextTick(() => {
          this.$emit('blur')
        })
      }
    },
  },
}
</script>

<style scoped>
</style>
